module.exports = __webpack_public_path__ + "img/business_img2.4e3a6e73.jpg";